import { useTranslation } from 'react-i18next'
import { Box, Flex, List, Text } from '@chakra-ui/react'
import Router from 'next/router'

import { ReconcilitationInfo } from 'appTypes/orders'
import { LeidYellowButton } from 'components/ui/Buttons/Button'
import { useCustomerInfo } from 'hooks/useCustomerInfo'
import { getPaymentSelectPageUrl } from 'utils/redirectUrlsBuilders'
import { removeDecimals } from 'utils/removeDecimals'
import { JSX } from 'react'

type Props = {
  reconciliations: ReconcilitationInfo[]
}

export const PayForReconciliationsButtons = ({ reconciliations }: Props): JSX.Element => {
  const { t } = useTranslation('common')
  const { customerInfo } = useCustomerInfo()

  const redirectToContinuePayment = (item: ReconcilitationInfo) => {
    const orderId = item.reconciliationOrder.id ?? 0

    const purchaseAs = customerInfo.organization ? 'organization' : 'person'

    Router.push(getPaymentSelectPageUrl(orderId, undefined, purchaseAs, true))
  }

  return (
    <Box width="100%">
      {reconciliations.length !== 0 && (
        <Flex justifyContent="center" alignItems="center" flexDirection="column" gridGap="12px">
          {reconciliations.map((item) => {
            return (
              <Box key={item.reconciliationOrder.id} width="100%">
                <LeidYellowButton key={item.reconciliationOrder.id} onClick={() => redirectToContinuePayment(item)}>
                  {t('payForReconcilliation')} ({removeDecimals(item.reconciliationOrder.totalPrice)} {t('NOK')})
                </LeidYellowButton>

                {item.orderItems.length !== 0 && (
                  <List.Root marginTop={5} textAlign="center" css={{ listStyleType: 'disc' }}>
                    {item.orderItems
                      .filter((s) => s.reconciliationDescription)
                      .map((orderItem) => (
                        <List.Item key={orderItem.id}>
                          <Text as="span" fontSize="md" fontWeight={300}>
                            {orderItem.reconciliationDescription}
                          </Text>
                        </List.Item>
                      ))}
                  </List.Root>
                )}
              </Box>
            )
          })}
        </Flex>
      )}
    </Box>
  )
}
